import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api';
import { State } from '@/store';
interface Props {
  vocabList: {
    name: string;
    words: string[];
    id: number;
  };
  country: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VocabList',
  props: {
    vocabList: null,
    country: { default: 'us' }
  },
  setup(__props: any) {

const $store = useStore<State>();


const deviceId = computed(() => $store.getters.deviceId);

return { __sfc: true,$store, deviceId }
}

})